import React from 'react';
import VegaIcon from './vegaIcons';
import { ATLAS_BULLETS } from './vegaData';

export default function VegaAtlas() {
  return (
    <section id="atlas" className="vd-section-y px-6 lg:px-10">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }} className="grid lg:grid-cols-2 gap-12 items-start">

        <div>
          <div className="vd-eyebrow" style={{ marginBottom: '1.25rem' }}>Atlas · product delivery</div>
          <h2
            className="vd-font-display vd-ink"
            style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)', lineHeight: 1.08, textWrap: 'balance' }}
          >
            Carrying your software <br />
            <span style={{ fontStyle: 'italic' }}>— with strength and reliability.</span>
          </h2>
          <p className="vd-ink-soft" style={{ marginTop: '1.5rem', maxWidth: '32rem', lineHeight: 1.7 }}>
            In ancient mythology, Atlas carried the heavens. Ours carries your software. A self-contained
            package — config, runtime, deploy scripts, monitoring — charted like a celestial map and shipped
            immutably to every cluster you run.
          </p>
          <div style={{ marginTop: '2rem' }}>
            <a href="#deploy" className="vd-btn-ghost" style={{ fontSize: '0.875rem' }}>
              See it deployed <VegaIcon name="arrow" className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="vd-grad-card-1 rounded-3xl relative overflow-hidden" style={{ padding: '1.75rem' }}>
          <div className="vd-star-dust absolute inset-0 pointer-events-none" style={{ opacity: 0.25 }} />
          <div style={{ position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span
                className="vd-pill"
                style={{ background: 'rgba(255,255,255,.7)', borderColor: 'rgba(255,255,255,.9)' }}
              >
                <VegaIcon name="atlas" className="w-3.5 h-3.5" /> Atlas package
              </span>
              <span style={{ fontSize: '0.75rem', color: 'rgba(51,65,85,.7)', fontFamily: '"JetBrains Mono", monospace' }}>v1.4.2</span>
            </div>

            <ul style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {ATLAS_BULLETS.map(b => (
                <li
                  key={b}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    background: 'rgba(255,255,255,.65)',
                    borderRadius: '0.75rem',
                    padding: '0.75rem 1rem',
                    fontSize: '0.875rem',
                    color: 'rgb(51,65,85)',
                  }}
                >
                  <span style={{ color: 'rgb(5,150,105)', flexShrink: 0 }}>
                    <VegaIcon name="check" className="w-4 h-4" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>

            <div style={{ marginTop: '1.25rem', fontSize: '0.75rem', color: 'rgba(51,65,85,.7)', fontFamily: '"JetBrains Mono", monospace' }}>
              $ vdk create ./atlas.yaml
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
